import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Menu = () => {
    const [openSubMenu, setOpenSubMenu] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const timeoutRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const toggleSubMenu = (index) => {
        setOpenSubMenu(openSubMenu === index ? null : index);
    };

    const handleMouseEnter = (index) => {
        clearTimeout(timeoutRef.current);
        setOpenSubMenu(index);
    };

    const handleMouseLeave = () => {
        timeoutRef.current = setTimeout(() => {
            setOpenSubMenu(null);
        }, 500);
    };

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    return (
        <nav className={`menu ${scrolled ? 'scrolled' : ''}`}>
            <div className="logo">
                <Link to="/">Stand</Link>
            </div>
            <div className={`menu-items ${menuOpen ? 'open' : ''}`}>
                <ul>
                    <li
                        onMouseEnter={() => handleMouseEnter(1)}
                        onMouseLeave={handleMouseLeave}
                    >
                        <Link to="/quem-somos">Quem Somos</Link>
                    </li>
                    <li
                        onMouseEnter={() => handleMouseEnter(1)}
                        onMouseLeave={handleMouseLeave}
                    >
                        <Link to="/servicos">Serviços</Link>
                    </li>
                    <li
                        onMouseEnter={() => handleMouseEnter(0)}
                        onMouseLeave={handleMouseLeave}
                    >
                        <Link to="/carros">Automóveis</Link>
                    </li>
                    <li
                        onMouseEnter={() => handleMouseEnter(0)}
                        onMouseLeave={handleMouseLeave}
                    >
                        <Link to="/contactos">Contactos</Link>
                    </li>
                </ul>
            </div>
            <div className="hamburger" onClick={toggleMenu}>
                <div className={`bar ${menuOpen ? 'open' : ''}`}></div>
                <div className={`bar ${menuOpen ? 'open' : ''}`}></div>
                <div className={`bar ${menuOpen ? 'open' : ''}`}></div>
            </div>
        </nav>
    );
};

export default Menu;